import React, {useMemo} from 'react';
import {connect} from 'react-redux';
import Container from 'react-bootstrap/Container';
import {
  isMobileBrowserDevice,
  normalizePermissionsList,
  userHasMobilePlatformAccess,
} from './mobilePlatformAccess';

function isAuthenticatedUser(authUser) {
  return authUser != null && authUser !== '';
}

const MobilePlatformGate = props => {
  const {children, globalPermissions, authPermissions, authUser} = props;

  const perms = useMemo(() => {
    const stored = typeof localStorage !== 'undefined' ? localStorage.getItem('userPermissions') : null;
    return normalizePermissionsList(stored, globalPermissions, authPermissions);
  }, [authUser, authPermissions, globalPermissions]);

  if (!isMobileBrowserDevice()) {
    return <>{children}</>;
  }

  if (!isAuthenticatedUser(authUser)) {
    return <>{children}</>;
  }

  if (userHasMobilePlatformAccess(perms)) {
    return <>{children}</>;
  }

  return (
    <Container className="push-down">
      <h1 style={{fontWeight: 'lighter'}}>Mobile access restricted</h1>
      <p>
        This application is not generally available on mobile browsers. Please use a desktop or laptop
        computer, or ask an administrator to grant the &quot;Allow Mobile Platform&quot; permission if you
        need mobile access.
      </p>
    </Container>
  );
};

const mapStateToProps = state => ({
  globalPermissions: state.globalState && state.globalState.permissions,
  authPermissions: state.auth && state.auth.permissions,
  authUser: state.auth && state.auth.authUser,
});

export default connect(mapStateToProps)(MobilePlatformGate);
